import React, {useEffect} from 'react';
import {Row, Button, Col} from 'react-bootstrap';
import styles from './transfer-instruction.module.scss';
import {
  CurrencyInput,
  DateInput,
  FormGroup,
  InputGroup,
  RadioButton,
  TextInput
} from "../../../../../components/form/form";
import {useValidation} from "../../../../../hooks/use-validation";
import {
  transferInstructionObj,
  transferInstructionValidator
} from "../../../../../form-control/transfer-form/transfer-form-control";
import {getGraduatedTaxStatusTypes, getSalutationTypes, getTaxStatusTypes} from "../../../../../helpr/transferFormData";

const TransferInstruction = ({context, controls}) => {
  //Unpack transfer form main context
  const { initialTransferInfoState, transferFormState, setTransferFormState } = context;
  const { next } = controls;

  //Setup validator and transfer instruction state
  const transferInstructionState = useValidation(
    transferInstructionValidator,
    transferInstructionObj(transferFormState),
    {border: '1px solid red'});
  const { validate, getTextFieldProps, getRadioButtonProps, forceSetField } = transferInstructionState;

  //Setup initial transfer info
  useEffect(() => {
    forceSetField('lastName', initialTransferInfoState.lastName);
    forceSetField('firstName', initialTransferInfoState.firstName);
  }, []);

  const nextPage = () => {
    const { formState, isFormValid } = validate();
    if(isFormValid){
      setTransferFormState({
        ...transferFormState,
        ...formState
      });
      next();
    }
  }

  //Radio Button Data

  return (
    <div className={styles['form-section']} >
      <Row>
        <Col lg={12}>
          <FormGroup header={'BONDHOLDER INFORMATION'}>
            <Row>
                <Col lg={12}>
                  <div>
                    Name:*
                  </div>
                </Col>
                <Col lg={3}>
                  <TextInput inputProps={getTextFieldProps('lastName')} placeholder={"Last Name"}>
                  </TextInput>
                </Col>
                <Col lg={3}>
                  <TextInput inputProps={getTextFieldProps('firstName')} placeholder={"First Name"}>
                  </TextInput>
                </Col>
                <Col lg={3}>
                  <TextInput inputProps={getTextFieldProps('middleName')} placeholder={"Middle Initial"}>
                  </TextInput>
                </Col>
            </Row>
            <Row>
              <Col lg={3}>
                <RadioButton inputProps={getRadioButtonProps('salutation')}
                             data={getSalutationTypes()} othersOption={false}>
                  Preferred Salutation:*
                </RadioButton>
              </Col>
              <Col lg={6}>
                <TextInput inputProps={getTextFieldProps('title')} placeholder={""}>
                  Title/Designation:
                </TextInput>
              </Col>
            </Row>
            <Row>
              <Col lg={12}>
                <div>
                  Email Address:
                </div>
              </Col>
            </Row>
            <Row>
              <Col lg={6}>
                <div>
                  <input type='text' disabled={true} value={initialTransferInfoState.emailAddress} />
                </div>
              </Col>
            </Row>
            <Row>
              <Col lg={12}>
                <div className={styles['section-spacing']}>
                </div>
              </Col>
            </Row>
          </FormGroup>
          <FormGroup header={"SECURITY INFORMATION AND ORDER AMOUNT"}>
            <Row>
              <Col lg={12}>
                <div>
                  Security Name:
                </div>
              </Col>
            </Row>
            <Row>
              <Col lg={6}>
                <div>
                  <input type='text' disabled={true} value={initialTransferInfoState.securityName} />
                </div>
              </Col>
            </Row>
            <Row>
              <Col lg={12}>
                <div className={styles['section-spacing']}>
                </div>
              </Col>
            </Row>
            <Row>
              <Col lg={12}>
                <div>
                  Security ID/ISIN No.:
                </div>
              </Col>
            </Row>
            <Row>
              <Col lg={6}>
                <div>
                  <input type='text' disabled={true} value={initialTransferInfoState.securityId} />
                </div>
              </Col>
            </Row>
            <Row>
              <Col lg={12}>
                <div className={styles['section-spacing']}>
                </div>
              </Col>
            </Row>
            <Row>
              <Col lg={6}>
                <CurrencyInput inputProps={getTextFieldProps('transferAmount')} placeholder={"In Figures"}>
                  Order Amount:*
                </CurrencyInput>
              </Col>
            </Row>
            <Row>
              <Col lg={6}>
                <div className={styles['in-words']}>
                  <input type='text' disabled={true} />
                </div>
              </Col>
            </Row>
            <Row>
              <Col lg={12}>
                <div className={styles['section-spacing']}>
                </div>
              </Col>
            </Row>
            <Row>
              <Col lg={3}>
                <DateInput inputProps={getTextFieldProps('purchaseDate')}>
                  Purchase Date:<br/>
                  <span className={styles['sub-label']}>(for Bank Issues only)</span>
                </DateInput>
              </Col>
            </Row>
          </FormGroup>
          <Row>
            <Col lg={6}>
              <div className={styles['input-group-section']}>
                <InputGroup header={"TAX STATUS:*"}>
                  <RadioButton inputProps={getRadioButtonProps('taxStatus')}
                               data={getTaxStatusTypes()} othersOption={true}>
                  </RadioButton>
                </InputGroup>
              </div>
            </Col>
            <Col lg={6}>
              <div className={styles['input-group-section']}>
                <InputGroup header={<>GRADUATED TAX STATUS <span className={styles['sub-label']}>(for Bank Issues only):</span></>}>
                  <RadioButton inputProps={getRadioButtonProps('graduatedTaxStatus')}
                               data={getGraduatedTaxStatusTypes()} othersOption={false}>
                  </RadioButton>
                </InputGroup>
              </div>
            </Col>
          </Row>
          <FormGroup header={"BROKER AND TRANSFER DATE DETAILS"}>
            <Row>
              <Col lg={12}>
                <div>
                  Broker Name:
                </div>
              </Col>
            </Row>
            <Row>
              <Col lg={6}>
                <div>
                  <input type='text' disabled={true} value={initialTransferInfoState.brokerName} />
                </div>
              </Col>
            </Row>
            <Row>
              <Col lg={12}>
                <div className={styles['section-spacing']}>
                </div>
              </Col>
            </Row>
            <Row>
              <Col lg={3}>
                <DateInput inputProps={getTextFieldProps('transferDate')}>
                  Transfer Date:*
                </DateInput>
              </Col>
              <Col lg={3}>
                <DateInput inputProps={getTextFieldProps('settlementDate')}>
                  Settlement Date:*
                </DateInput>
              </Col>
            </Row>
          </FormGroup>
        </Col>
      </Row>
      <Row className={styles['button-row']}>
        <Col lg={12}>
          <div className={styles['next-button']}>
            <Button onClick={() => nextPage()}>
              NEXT
            </Button>
          </div>
        </Col>
      </Row>
    </div>
  )
}

export default TransferInstruction;
